module.exports = fox => {
	'use strict';

	fox.registerWidget('MCP_Verification_Form', {
		configure() {
			this.registerOptions('', {
                '!template': 'verification_form',
                templateOptions: {phone: {number: 'xxxxxxx11'}}
			});

			this.callParent('configure', arguments);
		},

		// _handleFormValidation(formData) {
		// 	var isValid = true;

        //     formData.forEach(resp => {
		// 		var $elm = $(this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

		// 		if (resp.result === false) {
		// 			$elm.addClass('error');
		// 			$elm.find('.message').text(resp.message);
		// 			isValid = false;

		// 			return;
		// 		}

		// 		$elm.removeClass('error');
		// 		$elm.find('.message').text('');
		// 	});
		// },

		toggleFieldError(name, state, msg) {
            var $elm = $(`[name="${name}"]`).parent();
			
			if (state === true) {
				$elm.removeClass('error');
				$elm.find('.error-container').text('');
				
				return;
			}

			$elm.addClass('error');
            $elm.find('.error-container').text(msg);
        },
	}, 'Verification_Form');
};


// WEBPACK FOOTER //
// ./components/login-wizard/widget/verification-form.es.js